/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdditionServiceListByCreateOrderRespVo
 */
export interface GetAdditionServiceListByCreateOrderRespVo {
    /**
     * 附加服务编号
     * @type {number}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    serviceId?: number;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    serviceName?: string;
    /**
     * 附加服务中文名称
     * @type {string}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    serviceNameCn?: string;
    /**
     * 附加服务韩文名称
     * @type {string}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    serviceNameKr?: string;
    /**
     * 价格
     * @type {number}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    price?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    currencyCode?: string;
    /**
     * 是否选中：1-选中，2-不选中
     * @type {number}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    selected?: number;
    /**
     * 排序
     * @type {number}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    sort?: number;
    /**
     * 分组id
     * @type {number}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    groupId?: number;
    /**
     * 下单时是否显示 0不显示 1显示
     * @type {number}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    showOnOrder?: number;
    /**
     * 附加服务图片地址列表
     * @type {Array<string>}
     * @memberof GetAdditionServiceListByCreateOrderRespVo
     */
    imageUrls?: Array<string>;
}

/**
 * Check if a given object implements the GetAdditionServiceListByCreateOrderRespVo interface.
 */
export function instanceOfGetAdditionServiceListByCreateOrderRespVo(value: object): value is GetAdditionServiceListByCreateOrderRespVo {
    return true;
}

export function GetAdditionServiceListByCreateOrderRespVoFromJSON(json: any): GetAdditionServiceListByCreateOrderRespVo {
    return GetAdditionServiceListByCreateOrderRespVoFromJSONTyped(json, false);
}

export function GetAdditionServiceListByCreateOrderRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdditionServiceListByCreateOrderRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceId': json['serviceId'] == null ? undefined : json['serviceId'],
        'serviceName': json['serviceName'] == null ? undefined : json['serviceName'],
        'serviceNameCn': json['serviceNameCn'] == null ? undefined : json['serviceNameCn'],
        'serviceNameKr': json['serviceNameKr'] == null ? undefined : json['serviceNameKr'],
        'price': json['price'] == null ? undefined : json['price'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'selected': json['selected'] == null ? undefined : json['selected'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'showOnOrder': json['showOnOrder'] == null ? undefined : json['showOnOrder'],
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
    };
}

export function GetAdditionServiceListByCreateOrderRespVoToJSON(json: any): GetAdditionServiceListByCreateOrderRespVo {
    return GetAdditionServiceListByCreateOrderRespVoToJSONTyped(json, false);
}

export function GetAdditionServiceListByCreateOrderRespVoToJSONTyped(value?: GetAdditionServiceListByCreateOrderRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceId': value['serviceId'],
        'serviceName': value['serviceName'],
        'serviceNameCn': value['serviceNameCn'],
        'serviceNameKr': value['serviceNameKr'],
        'price': value['price'],
        'currencyCode': value['currencyCode'],
        'selected': value['selected'],
        'sort': value['sort'],
        'groupId': value['groupId'],
        'showOnOrder': value['showOnOrder'],
        'imageUrls': value['imageUrls'],
    };
}

